import { useTranslation } from "react-i18next";

export const TranslatedComponent = ({ children }: any) => {
  const { t } = useTranslation();

  // Pass translated strings as props to children
  return children({ t });
};
